// src/PrivacyPolicy.js
import React from 'react';
import './privacypolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>SnapEstate Application Privacy Policy</h1>
      
      <h2>1. Introduction</h2>
      <p>
        This privacy policy describes how SnapEstate, an application developed by Caumont Immobilier, collects, uses and protects the personal information of its users. By using the application, you accept the practices described in this policy.
      </p>

      <h2>2. Data Controller</h2>
      <p>
        The data controller is:<br />
        Caumont Immobilier<br />
        Address: 154 rue Victor Hugo 76600 LE HAVRE, France<br />
        SIRET number: 910 946 870 00014<br />
        Contact: contact@caumont-immo.fr
      </p>

      <h2>3. Data Collected</h2>
      <p>
        SnapEstate may collect the following types of data:
      </p>
      <ul>
        <li>Identification information: first name, last name, email address, telephone number.</li>
        <li>Professional data: name of the real estate agency, professional address.</li>
        <li>Technical data: information on the device used, IP address, connection data.</li>
        <li>Location data: geographic location of the user, if permission is granted.</li>
        <li>Photos and media: images captured via the application for professional needs.</li>
      </ul>

      <h2>4. Use of Data</h2>
      <p>
        The data collected is used to:
      </p>
      <ul>
        <li>Provide and improve the application services.</li>
        <li>Enable real estate professionals to take quality photos.</li>
        <li>Provide customer support and communication with users.</li>
        <li>Analyze the use of the application for future improvements.</li>
        <li>Comply with legal and regulatory obligations.</li>
      </ul>

      <h2>5. Sharing of Data</h2>
      <p>
        Caumont Immobilier undertakes not to sell, rent or disclose your personal data to third parties, except in the following cases:
      </p>
      <ul>
        <li>With your explicit consent.</li>
        <li>To comply with a legal or regulatory obligation.</li>
        <li>With third-party service providers for the operation of the application (subcontractors), provided that they comply with strict confidentiality obligations.</li>
      </ul>

      <h2>6. Data Security</h2>
      <p>
        We implement appropriate technical and organizational measures to protect your data against unauthorized access, disclosure, alteration or destruction.
      </p>

      <h2>7. Data Retention</h2>
      <p>
        Personal data is retained for the period necessary for the purposes for which it was collected, unless otherwise required by law.
      </p>

      <h2>8. Subscription Details</h2>
      <p>
        Subscription Title: SnapEstate Monthly<br />
        Length of Subscription: 1 Month (Auto-renewable)<br />
        Price: $69.99 USD per month<br />
        Payment: Charged to your Apple ID at confirmation of purchase.<br />
        Auto-Renewal: Subscription automatically renews unless canceled at least 24 hours before the end of the current period.<br />
        Manage Subscription: You can manage or cancel your subscription in your account settings on the App Store after purchase.
      </p>

      <h2>9. Subscription benefits</h2>
      <ul>
        <li>Ad-Free Enjoyment: Enjoy your favorite content without any pesky ads, creating a seamless environment.</li>
        <li>Unlimited Access: Dive into a vast array of resources, courses, or entertainment without limits</li>
        <li>Priority Customer Support: Stay ahead of the curve with early access privileges, ensuring you never miss out.</li>
        <li>Customization Options: Unlock advanced customization options, from themes to settings, providing a personalized touch to your interaction with our platform.</li>
      </ul>

      <h2>10. Your Rights</h2>
      <p>
        In accordance with the GDPR, you have the following rights:
      </p>
      <ul>
        <li>Right of access: obtain confirmation that your data is being processed and access this data.</li>
        <li>Right of rectification: request the correction of inaccurate or incomplete data.</li>
        <li>Right to erasure: request the deletion of your data under certain conditions.</li>
        <li>Right to restriction of processing: request the restriction of the processing of your data under certain conditions.</li>
        <li>Right to object: object to the processing of your data for legitimate reasons.</li>
        <li>Right to portability: receive your data in a structured and commonly used format, and transmit it to another data controller.</li>
      </ul>
      <p>
        To exercise these rights, please contact:<br />
        Caumont Immobilier<br />
        Address: 154 rue Victor Hugo 76600 LE HAVRE, France<br />
        Contact: contact@caumont-immo.fr
      </p>

      <h2>11. Changes to the Privacy Policy</h2>
      <p>
        Caumont Immobilier reserves the right to modify this privacy policy at any time. Changes will be notified via the application or by other appropriate means.
      </p>

      <h2>12. Contact</h2>
      <p>
        For any questions regarding this privacy policy, please contact:<br />
        Caumont Immobilier<br />
        Address: 154 rue Victor Hugo 76600 LE HAVRE, France<br />
        Contact: contact@caumont-immo.fr<br /><br />
        This privacy policy is effective as of December 24, 2024.
      </p>
    </div>
  );
};

export default PrivacyPolicy;